import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL

export default axios.create({
  baseURL: `${baseURL}/dashboard`,
  headers: { 'X-CSRF-Token': null }
})

export const apiRoot = axios.create({
  baseURL: `${baseURL}/`,
  headers: { 'X-CSRF-Token': null }
})
